export const extConfig = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    deviation: {
        defaultWidth: 430,
        canLink: true
    },
    gallery: {
        defaultWidth: 430,
        defaultAlignment: 'center',
        defaultGridItemWidth: 250,
        defaultGridItemHeight: 200,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 200,
        defaultLayoutSpacing: 8,
        canLink: true
    },
    anchor: false,
    blockDragging: false,
    blockquote: true,
    heading: true,
    mention: true,
    paste: true,
    textAlignment: true,
    textColor: false,
    textFont: false,
    textHighlight: false,
    history: true,
    allowUploads: true,
    gif: {
        defaultWidth: 780,
        canAlign: true,
        defaultAlignment: 'center'
    },
    indent: {
        captureTab: false
    }
};
export const extConfigFullscreen = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    deviation: {
        defaultWidth: 780
    },
    gallery: {
        defaultWidth: 780,
        defaultAlignment: 'center',
        defaultGridItemWidth: 250,
        defaultGridItemHeight: 200,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 200,
        defaultLayoutSpacing: 8
    },
    anchor: false,
    blockDragging: true,
    blockquote: true,
    heading: true,
    mention: true,
    paste: true,
    textAlignment: true,
    textColor: false,
    textFont: false,
    textHighlight: false,
    history: true,
    allowUploads: true,
    gif: {
        defaultWidth: 780,
        canAlign: true,
        defaultAlignment: 'center'
    },
    indent: {
        captureTab: true
    }
};

//# sourceMappingURL=config.js.map